import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import React, { useEffect, useRef, useState } from 'react'

export default function RequesterFlowCloseModal({ open = false, onBack = () => {}, onClose = () => {} }) {
  const [show, setShow] = useState(open)
  const overlayRef = useRef(null)

  useEffect(() => setShow(open), [open])

  const handleClose = () => {
    setShow(false)
    onClose()
  }

  const handleClickOutsideModal = (e) => {
    if (e.target !== overlayRef.current) return
    onBack()
  }

  return (
    <Portal>
      <div className={clsx('requester-flow-modal-overlay dome-full-width dome-full-height', show && 'show')}>
        <div
          className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center"
          onClick={handleClickOutsideModal}
          ref={overlayRef}
        >
          <div className="requester-flow-close-container dome-d-flex dome-flex-column dome-gap24">
            <div className="dome-d-flex dome-flex-column dome-gap12">
              <i style={{ fontSize: '50px' }} className="fa-thin fa-circle-exclamation dome-color-red-alert"></i>
              <span className="dome-h2 dome-color-red-alert">are you sure?</span>
            </div>
            <span className="dome-p1 dome-text-w300 dome-color-darkest-grey">
              You’ll have to re-initiate a request if you close this form now.
            </span>
            <div className="dome-d-flex dome-justify-between">
              <button
                type="button"
                onClick={onBack}
                className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
              >
                back
              </button>
              <button type="button" onClick={handleClose} className="dome-btn dome-btn-base dome-btn-red-stroke">
                close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}
